import { collection, doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebase";

export function listenToCelebrityDesigns(onSuccess, onError) {
  return onSnapshot(collection(db, "celebrity_designs"), (snapshot) => {
    const designs = snapshot.docs
      .map((entry) => {
        const data = entry.data();
        return { id: entry.id, ...data, imageUrl: data.websiteImageUrl || data.imageUrl || "" };
      })
      .filter((design) => design.isActive !== false && design.imageUrl)
      .sort((a, b) => Number(a.displayOrder || 0) - Number(b.displayOrder || 0));
    onSuccess(designs);
  }, onError);
}

export function listenToCelebrityHomeImages(onSuccess, onError) {
  return onSnapshot(doc(db, "celebrity_design_settings", "home"), (snapshot) => {
    const data = snapshot.data() || {};
    const appImages = Array.isArray(data.imageUrls) ? data.imageUrls : [];
    const websiteImages = Array.isArray(data.websiteImageUrls) ? data.websiteImageUrls : [];
    const images = Array.from({ length: Math.max(appImages.length, websiteImages.length) }, (_, index) => websiteImages[index] || appImages[index] || "")
      .filter(Boolean)
      .slice(0, 10);
    onSuccess(images);
  }, onError);
}